module.exports = __webpack_public_path__ + "static/img/1_2.b058392.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new/1_2.png
// module id = amTf
// module chunks = 0